export default __webpack_public_path__ + "static/media/ghost.a1c8ac28.svg";